import React, { useState } from "react";

const SuccessMessage = () => {
  const [showMessage, setShowMessage] = useState(true);

  setTimeout(() => {
    setShowMessage(false);
  }, 1550);

  return (
    <>
      {showMessage && (
        <p className="bg-green-500 text-white text-center py-2 fixed inset-x-0 top-0">
          Success
        </p>
      )}
    </>
  );
};

export default SuccessMessage;
